import { Formik, FormikHelpers } from "formik";
import { useFormSubmit, useUserToken, } from "melco-shared-logic";
import { useTranslation } from "react-i18next";
import { DirtyFormPrompt } from "../../form/DirtyFormPrompt";
import { Drawer as DrawerType } from "../../../hooks/drawer/useGenericDrawer";
import { DisplayEditCouponForm } from "./DisplayEditCouponForm";
import { useEditCoupon } from "../../../hooks/coupons/useEditCoupon";
import dayjs from "dayjs";

export type SubmitAction = "edit";

export type EditCouponFormValueInterface = {
  id: string | null;
  type: number | undefined,
  code: string,
  description: string,

  value: number | undefined,
  product_code: string,
  start_date?: Date | null;
  end_date?: Date | null,
  usage_count: number | undefined,
  usage_type: number | undefined
};

type EditCouponFormProps = {
  referenceDrawer: DrawerType;
  onCloseDrawer: (closeDrawer: boolean) => void;
  CouponDetails: any;
};

export const EditCouponForm: React.FC<EditCouponFormProps> = ({
  referenceDrawer,
  onCloseDrawer,
  CouponDetails,
}) => {
  const { t } = useTranslation();
  const token = useUserToken();
  const editCoupon = useEditCoupon();

  const onSubmit = async (
    values: EditCouponFormValueInterface,
    formikHelpers: FormikHelpers<EditCouponFormValueInterface>
  ) => {
    console.log(values);

    await onAddNewCoupon(values, formikHelpers, {
      isManuallyResettingForm: true,
    });
  };

  const initialValues: EditCouponFormValueInterface = {
    id: CouponDetails.id ? CouponDetails.id : "",
    type: CouponDetails.type ? CouponDetails.type : "",
    code: CouponDetails.code ? CouponDetails.code : "",
    description: CouponDetails.description ? CouponDetails.description : "",

    value: CouponDetails.value ? CouponDetails.value : undefined,
    product_code: CouponDetails.product_code ? CouponDetails.product_code : "",
    start_date: CouponDetails.start_date ? dayjs(CouponDetails.start_date).startOf("day").toDate() : undefined,
    end_date: CouponDetails.end_date ? dayjs(CouponDetails.end_date).endOf("day").toDate() : undefined,
    usage_count: CouponDetails.usage_count ? CouponDetails.usage_count : undefined,
    usage_type: CouponDetails.usage_type ? CouponDetails.usage_type : undefined

  };

  const handleEditCoupon = async (
    values: EditCouponFormValueInterface,
    formikHelpers: FormikHelpers<EditCouponFormValueInterface>,
    options: {}
  ) => {
    const response = await editCoupon({ ...values });
    if (response?.success) {
      formikHelpers.resetForm();
      onCloseDrawer(false);
    }
  };

  const formSubmitToAddNewCoupon = () => {
    return [
      async (
        values: EditCouponFormValueInterface,
        formikHelpers: FormikHelpers<EditCouponFormValueInterface>
      ) => {
        return handleEditCoupon(values, formikHelpers, {});
      },
      {
        translationOptions: {
          batchNumber: 1,
        },
        translationPrefix: ["coupons.actions", "add_new"].join("."),
        onError: () => {
          // refetch entity from server
          //  queryClient.invalidateQueries(queryKey);
        },
      },
    ] as const;
  };

  const onAddNewCoupon = useFormSubmit(...formSubmitToAddNewCoupon());

  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
      >
        <DirtyFormPrompt>
          <DisplayEditCouponForm
            CouponDetails={CouponDetails}
          ></DisplayEditCouponForm>
        </DirtyFormPrompt>
      </Formik>
    </>
  );
};
